import "./HoveredElementInfo.css";

const InfoRow = ({ label, value }) => (
  <div className="info-row">
    <span className="info-label">{label}</span>
    <span className="info-value">{value}</span>
  </div>
); 


const HoveredElementInfo = ({ isVisible, position, element }) => {
  if (!isVisible || !position.x || !position.y) return null;

  return (
    <div
      className="hovered-element-info"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
      }}
    >
      <div className="info-content">
        <InfoRow label="Name" value={element?.name || "-"} />
        <InfoRow label="Type" value={element?.objectType || "-"} />
        
        {element?.objectType === "rack" && (
          <InfoRow label="Bins" value={element?.totalBins || "0"} />
        )}
        
        <InfoRow 
          label="Dimensions" 
          value={`${element?.convertedLength || "0"} × ${element?.convertedBreadth || "0"}`} 
        />
      </div>
    </div>
  );
};

 
export default HoveredElementInfo;